// import { useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
// import { ReactComponent as ArrowRightIcon } from "../assets/svg/keyboardArrowRightIcon.svg";
// import { toast } from "react-toastify";
// import visibilityIcon from "../assets/svg/visibilityIcon.svg";
// import OAuth from "../components/OAuth";

// function SignIn() {
//   const [showPassword, setShowPassword] = useState(false);
//   const [formData, setFormData] = useState({
//     email: "",
//     password: "",
//   });

//   const { email, password } = formData;

//   const navigate = useNavigate();

//   const onchange = (e) => {
//     setFormData((prevState) => ({
//       ...prevState,
//       [e.target.id]: e.target.value,
//     }));
//   };

//   const onSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const auth = getAuth();
//       const userCredential = await signInWithEmailAndPassword(
//         auth,
//         email,
//         password
//       );

//       if (userCredential.user) {
//         navigate("/");
//       }
//     } catch (error) {
//       toast.error("Bad User Credentials");
//     }
//   };
//   return (
//     <>
//       <div className="pageContainer">
//         <header>
//           <p className="pageHeader">Welcome Back</p>
//         </header>
//         <form onSubmit={onSubmit}>
//           <input
//             type="email"
//             className="emailInput"
//             placeholder="Enter Email"
//             id="email"
//             value={email}
//             onChange={onchange}
//           />
//           <div className="passwordInputDiv">
//             <input
//               type={showPassword ? "text" : "password"}
//               placeholder="Enter Password"
//               className="passwordInput"
//               id="password"
//               value={password}
//               onChange={onchange}
//             />
//             <img
//               src={visibilityIcon}
//               alt="showPassword"
//               onClick={() => setShowPassword((prevState) => !prevState)}
//               className="showPassword"
//             />
//           </div>

//           <Link to="/forgot-password" className="forgotPasswordLink">
//             Forgot Password
//           </Link>
//           <div className="signInBar">
//             <p className="signInText">Sign In</p>
//             <button className="signInButton">
//               <ArrowRightIcon fill="#ffffff" width="34px" height="34px" />
//             </button>
//           </div>
//         </form>

//         <OAuth />
//         <Link to="/sign-up" className="registerLink">
//           Sign Up Instead
//         </Link>
//       </div>
//     </>
//   );
// }

// export default SignIn;

import { useState } from "react";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import OAuth from "../components/OAuth";
import { ReactComponent as ArrowRightIcon } from "../assets/svg/keyboardArrowRightIcon.svg";
import visibilityIcon from "../assets/svg/visibilityIcon.svg";

function SignIn() {
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const { email, password } = formData;

  const navigate = useNavigate();

  const onChange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.id]: e.target.value,
    }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    try {
      const auth = getAuth();

      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );

      if (userCredential.user) {
        navigate("/");
      }
    } catch (error) {
      toast.error("Bad User Credentials");
    }
  };

  return (
    <>
      <div className="pageContainer">
        <header>
          <p className="pageHeader">Welcome Back!</p>
        </header>

        <form onSubmit={onSubmit}>
          <input
            type="email"
            className="emailInput"
            placeholder="Email"
            id="email"
            value={email}
            onChange={onChange}
          />

          <div className="passwordInputDiv">
            <input
              type={showPassword ? "text" : "password"}
              className="passwordInput"
              placeholder="Password"
              id="password"
              value={password}
              onChange={onChange}
            />

            <img
              src={visibilityIcon}
              alt="show password"
              className="showPassword"
              onClick={() => setShowPassword((prevState) => !prevState)}
            />
          </div>

          <Link to="/forgot-password" className="forgotPasswordLink">
            Forgot Password
          </Link>

          <div className="signInBar">
            <p className="signInText">Sign In</p>
            <button className="signInButton">
              <ArrowRightIcon fill="#ffffff" width="34px" height="34px" />
            </button>
          </div>
        </form>

        <OAuth />

        <Link to="/sign-up" className="registerLink">
          Sign Up Instead
        </Link>
      </div>
    </>
  );
}

export default SignIn;
